export default "__VITE_ASSET__RgEB0$Xv__"